import type { ChatMessage } from "../shared/types";

export const assistantHistoryStorageKey = "omer-assistant-history";

export type AssistantHistory = {
  conversationId: string;
  messages: ChatMessage[];
};

export const initialAssistantMessage: ChatMessage = {
  id: "welcome",
  role: "assistant",
  content: "Hello — I’m Omer’s experimental AI assistant: conversational, still in progress, and occasionally buggy in the charming-but-verify-me way. Ask a serious question, a curious one, or type / to choose a skill.",
};

function isChatMessage(value: unknown): value is ChatMessage {
  if (!value || typeof value !== "object") return false;
  const message = value as Partial<ChatMessage>;
  return typeof message.id === "string"
    && (message.role === "user" || message.role === "assistant")
    && typeof message.content === "string";
}

export function parseAssistantHistory(value: unknown): AssistantHistory | undefined {
  if (!value || typeof value !== "object") return undefined;
  const history = value as Partial<AssistantHistory>;
  if (typeof history.conversationId !== "string" || !Array.isArray(history.messages)) return undefined;
  if (history.messages.length === 0 || history.messages.length > 100 || !history.messages.every(isChatMessage)) return undefined;
  return { conversationId: history.conversationId, messages: history.messages };
}

export function loadAssistantHistory(): AssistantHistory | undefined {
  try {
    const raw = window.sessionStorage.getItem(assistantHistoryStorageKey);
    return raw ? parseAssistantHistory(JSON.parse(raw)) : undefined;
  } catch {
    return undefined;
  }
}

export function saveAssistantHistory(history: AssistantHistory): void {
  try {
    window.sessionStorage.setItem(assistantHistoryStorageKey, JSON.stringify(history));
  } catch {
    // A disabled or full browser store must not interrupt the chat.
  }
}
